// extracted by mini-css-extract-plugin
module.exports = {"giftCardImageContainer":"gift-card-image_giftCardImageContainer__lhjo0","giftCardImage":"gift-card-image_giftCardImage__xmd3p"};